<template>
  <v-sheet>
    <v-card>
      <v-card-title>
        <span class="title">Notifications</span>
      </v-card-title>
      <v-card-text>
        <v-list three-line>
          <v-list-item
            @click="navigateTo('calls')"
            v-if="showCallsNotification"
          >
            <v-list-item-icon>
              <v-icon class="mr-4">mdi-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="notify-item-content">
              <v-list-item-title>Calls</v-list-item-title>
              <v-list-item-subtitle>{{
                callsNotificationText
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="navigateTo('chats')"
            v-if="showChatsNotification"
          >
            <v-list-item-icon>
              <v-icon class="mr-4">mdi-chat</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="notify-item-content">
              <v-list-item-title>Chats</v-list-item-title>
              <v-list-item-subtitle>{{
                chatsNotificationText
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="navigateTo('messages')"
            v-if="showMessagesNotification"
          >
            <v-list-item-icon>
              <v-icon class="mr-4">mdi-message</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="notify-item-content">
              <v-list-item-title>Messages</v-list-item-title>
              <v-list-item-subtitle>{{
                messagesNotificationText
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
            @click="navigateTo('reviews')"
            v-if="showReviewsNotification"
          >
            <v-list-item-icon>
              <v-icon class="mr-4">mdi-star</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="notify-item-content">
              <v-list-item-title>Reviews</v-list-item-title>
              <v-list-item-subtitle
                >It has been 14 days since your last review, ask for more
                reviews let's see how long we can actually go before it has
                problems</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="showNoNotifications">
            <v-list-item-content class="notify-item-content">
              <v-list-item-title>You have no notifications</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
import {} from "../../globalVars";

export default {
  name: "Notifications",
  components: {},
  data() {
    return {
      showSearchResults: false,
      searchTerm: "",
      searchFocus: false
    };
  },
  async created() {},
  computed: {
    userId() {
      return this.$store.getters["entities/settings/query"]().first().userId;
    },
    user() {
      return this.$store.getters["entities/users/find"](this.userId);
    },
    settings() {
      return this.$store.getters["entities/settings/query"]().first();
    },
    showNoNotifications() {
      return (
        this.settings &&
        !(
          this.showMessagesNotification ||
          this.showCallsNotification ||
          this.showChatsNotification ||
          this.showReviewsNotification
        )
      );
    },
    showCallsNotification() {
      return this.settings && this.settings.callIsUnreadCount > 0;
    },
    callsNotificationText() {
      let text = "You have";
      if (this.settings.callIsUnreadCount > 0) {
        text += ` ${this.settings.callIsUnreadCount} new calls`;
      }
      return text;
    },
    showMessagesNotification() {
      return (
        this.settings &&
        this.settings.messageIsUnreadCount +
          this.settings.messageHaveNotRespondedCount >
          0
      );
    },
    messagesNotificationText() {
      let text = "You have";
      if (this.settings.messageIsUnreadCount > 0) {
        text += " " + this.settings.messageIsUnreadCount + " new messages";
      }
      if (this.settings.messageHaveNotRespondedCount > 0) {
        if (this.settings.messageIsUnreadCount > 0) {
          text += ", and";
        }
        text +=
          " " +
          this.settings.messageHaveNotRespondedCount +
          " messages without a response";
      }
      return text;
    },
    showChatsNotification() {
      return (
        this.settings &&
        this.settings.chatIsUnreadCount +
          this.settings.chatHaveNotRespondedCount >
          0
      );
    },
    chatsNotificationText() {
      let text = "You have";
      if (this.settings.chatIsUnreadCount > 0) {
        text += " " + this.settings.chatIsUnreadCount + " new chats";
      }
      if (this.settings.chatHaveNotRespondedCount > 0) {
        if (this.settings.chatHaveNotRespondedCount > 0) {
          text += ", and";
        }
        text +=
          " " +
          this.settings.chatHaveNotRespondedCount +
          " chats without a response";
      }
      return text;
    },
    showReviewsNotification() {
      return false;
    }
  },
  methods: {
    navigateTo(routeName) {
      if (this.$route.name != routeName) {
        this.$store.dispatch("entities/users/update", {
          where: this.userId,
          data: { currentCustomerId: null }
        });
        this.$router.push({ name: routeName });
      }
    }
  },
  watch: {}
};
</script>

<style lang="stylus" scoped>
.v-list--three-line div.notify-item-content {
  align-self: center;
}
</style>
